import { Outlet } from 'react-router-dom';

import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';

import { MissionsCategoryTabsLayout } from 'components/missions/MissionsCategoryTabsLayout';

const MissionsCategoryLayout = () => {
  const isDesktopAndAbove = useIsDesktopAndAbove();

  return (
    <ConditionalWrapper
      Wrapper={MissionsCategoryTabsLayout}
      wrap={!isDesktopAndAbove}
    >
      <Outlet />
    </ConditionalWrapper>
  );
};

export default MissionsCategoryLayout;
